import React from "react";
import axios from "axios";
import "./ListApplicationVR.css";
import { useDispatch, useSelector } from "react-redux";

import SlidingPane from "react-sliding-pane";
import { applicationVR_Reducer, sidebarReducer } from "../../Redux/store";
import { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";
function ListApplicationVR() {
  //dispatch the data to redux
  const dispatch = useDispatch();
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;

  // Add Application VR
  const [newApplication, setNewApplication] = useState(null);
  const [newIntendedDevice, setNewIntendedDevice] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [newAppOS, setAppOS] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  const [newDivisionId, setNewDivisionId] = useState(null);
  const [IsDependent, setIsDependent] = useState(false);
  //Edit Application VR
  const [applicationId, setApplicationId] = useState(null);
  const [applicationName, setApplicationName] = useState(null);
  const [intendedDevice, setIntendedDevice] = useState("");
  const [appDescription, setApplicationDescription] = useState("");
  const [appStatus, setAppStatus] = useState("");
  const [appOS, setApplicationOS] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState(null);

  // for showing heading in MUI select Tag
  const [intendedDeviceName, setIntendedDeviceName] = useState("");
  const [appOSheading, setApplicationOSheading] = useState(null);
  const [divisionName, setDivisionName] = useState("");
  const [businessunitName, setBusinessunitName] = useState("");
  const [businessunitData, setBusinessunitData] = useState("");

  //spinner for API
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  // for storing data in redux
  const application_name = useSelector(
    (state) => state.applicationVR.application_name
  );
  const application_intended_device = useSelector(
    (state) => state.applicationVR.application_intended_device
  );
  const application_description = useSelector(
    (state) => state.applicationVR.application_description
  );
  const application_OS = useSelector(
    (state) => state.applicationVR.application_OS
  );
  const applicationstatus = useSelector(
    (state) => state.applicationVR.application_status
  );
  const application_bu = useSelector(
    (state) => state.applicationVR.application_bu
  );
  const application_division = useSelector(
    (state) => state.applicationVR.application_division
  );

  //permissions
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );

  //state hook for listApplication  API's
  const [ListApp, setListApp] = useState([]);
  const [AppCount, setAppCount] = useState(null);
  const [divisionData, setdivisionData] = useState([]);
  const [buData, setBuData] = useState([]);

  // for filtering
  const [AppFilter, setAppFilter] = useState("");
  const [AppselData, setAppselData] = useState("");

  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);

  const [dummyAppfilter, setDummyAppfilter] = useState("");
  const [dummyAppselData, setDummyselData] = useState("");

  // for opening the sliding pane
  const application_IsPane = useSelector(
    (state) => state.applicationVR.applicationIsPane
  );
  const addapplication_IsPane = useSelector(
    (state) => state.applicationVR.addapplicationIsPane
  );
  const application_filter = useSelector(
    (state) => state.applicationVR.application_filter
  );
  const bu_edit = useSelector((state) => state.applicationVR.bu_edit);

  //Add Application and Edit Application related selectors
  const application_edit = useSelector(
    (state) => state.applicationVR.application_edit
  );

  //Add content pop up
  const [popUp, setPopUp] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    // height: 300,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };
  async function onEdit(item) {
    await axios
      .get(
        `vr_applications/listvrapplicationbyid/${item.te_application_id}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("response on edit", response);
          setApplicationId(response.data.data.te_application_id);
          setApplicationName(response.data.data.te_application_name);
          setApplicationDescription(response.data.data.te_appdescription);
          setIntendedDeviceName(intendedDeviceName);
          setIntendedDeviceName(response.data.data.te_intended_device);
          setIntendedDevice(response.data.data.te_intended_device);

          setIsDependent(response.data.data.dependency); //to check

          setApplicationOS(response.data.data.te_appos);
          setApplicationOSheading(response.data.data.te_appos);
          setAppStatus(response.data.data.te_appstatus);
          setBusinessunitData(businessunitData);
          setBusinessunitData(response.data.data.te_buname);
          setBusinessunitName(response.data.data.te_buname);
          setDivisionName(response.data.data.te_divisionname);
          setEditDivisionId(response.data.data.te_divisionid);

          dispatch(
            applicationVR_Reducer.application_id(
              response.data.data.te_application_id
            )
          );
          dispatch(
            applicationVR_Reducer.application_name(
              response.data.data.te_application_name
            )
          );
          dispatch(
            applicationVR_Reducer.application_intended_device(
              response.data.data.te_intended_device
            )
          );
          dispatch(
            applicationVR_Reducer.application_description(
              response.data.data.te_appdescription
            )
          );
          dispatch(
            applicationVR_Reducer.application_OS(response.data.data.te_appos)
          );
          dispatch(
            applicationVR_Reducer.application_status(
              response.data.data.te_appstatus
            )
          );
          dispatch(
            applicationVR_Reducer.application_bu(response.data.data.te_buname)
          );
          dispatch(
            applicationVR_Reducer.application_division(
              response.data.data.te_divisionid
            )
          );
          dispatch(applicationVR_Reducer.application_IsPane(true));
          dispatch(applicationVR_Reducer.application_filter(true));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        console.log("response on error", err);
      });
  }

  //Update application API
  const newApplication_data = {
    applicationId: applicationId,
    applicationName: applicationName,
    intendeddevice: intendedDevice,
    applicationDescription: appDescription,
    applicationStatus: appStatus,
    appOs: appOS,
    divisionid: editDivisionId,
  };
  const onUpdate = async (applicationId) => {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(
        `vr_applications/update/${applicationId}`,
        newApplication_data,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Application name '${newApplication_data.applicationName}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.update_success(true));
          }

          // Application name 'App1' already exists
          dispatch(applicationVR_Reducer.application_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListApplicationVR"));
          dispatch(applicationVR_Reducer.application_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  // Cancel button function
  const onCancel = async () => {
    setApplicationName(application_name);
    setIntendedDevice(application_intended_device);
    setAppStatus(applicationstatus);
    setApplicationDescription(application_description);
    setApplicationOS(application_OS);
    setDivisionName(application_division);
    setBusinessunitName(application_bu);
    dispatch(applicationVR_Reducer.application_edit(false));
  };
  //Header for API's
  const options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  //Pagenation
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, AppselData, AppFilter);
  };

  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, AppselData, AppFilter);
  };

  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, AppselData, AppFilter);
  };

  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, AppselData, AppFilter);
  };

  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      // dispatch(sidebarReducer.apiLoad(true));
      setPageSelected(pageNo);
      setListApp([]);

      await axios
        .get(`vr_applications/list/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            setListApp(response.data.data.rows);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        });
    } else if (isFiltered) {
      setPageSelected(pageNo);

      if (!isFilterIReset) {
        // dispatch(sidebarReducer.apiLoad(true));
        if (TargetColomn === "te_appstatus") {
          let status = AppFilter.toLowerCase();

          if (status === "active") {
            keyWord = "1";
          } else if (status === "inactive") {
            keyWord = "0";
          }
        }
        await axios
          .get(
            `vr_applications/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              // dispatch(sidebarReducer.apiLoad(false));
              setListApp(response.data.data.rows);
            } else if (response.status !== 200) {
              // dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            // dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      } else if (isFilterIReset) {
        // dispatch(sidebarReducer.apiLoad(true));
        if (dummyAppfilter === "te_appstatuss") {
          let status = dummyAppfilter.toLowerCase();
          if (status === "active") {
            keyWord = "1";
            // setDivfilter("1");
          } else if (status === "inactive") {
            keyWord = "0";
            // setDivfilter("0");
          }
        } else if (dummyAppselData !== "te_appstatus") {
          keyWord = dummyAppfilter;
        }
        await axios
          .get(
            `vr_applications/list/?page=${pageNo}&limit=${listLimit}&${dummyAppselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              //dispatch(sidebarReducer.apiLoad(false));
              // setListApp(response.data.data.rows);
            } else if (response.status !== 200) {
              //dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            // dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    }
  };
  async function responseData() {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`vr_applications/list/?&limit=${listLimit}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));

          let pages =
            response.data.data.count === 0
              ? 1
              : Math.ceil(response.data.data.count / listLimit);
          setNoOfPages(pages);
          setAppCount(response.data.data.count);

          return setListApp(response.data.data.rows);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        console.log("response error", err);
      });

    await axios
      .get(`businessunit/listactive`, options)
      .then((response) => {
        if (response.status === 200) {
          // console.log(response.data.data, "resp");
          // dispatch(sidebarReducer.apiLoad(false));
          setBuData(response.data.data);
          //setBuData(buData);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  // division response for Division Dropdown
  async function DivisionResponse(opt) {
    //setApiLaod(true);
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`division/listactive/${opt}`, options)
      .then((response) => {
        if (response.status === 200) {
          // dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          return setdivisionData(response.data.data);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
      });
  }

  // Add the new application
  const newAddApplication_data = {
    applicationName: newApplication,
    intendeddevice: newIntendedDevice,
    applicationDescription: newDescription,
    applicationStatus: newStatus,
    appOs: newAppOS,
    divisionid: newDivisionId,
  };
  const onAddapplication = async (e) => {
    e.preventDefault();
    // dispatch(sidebarReducer.apiLoad(true));

    await axios
      .post("vr_applications/create", newAddApplication_data, options)
      .then((response) => {
        if (response.status === 200) {
          //dispatch(sidebarReducer.apiLoad(false));
          console.log(
            "response add VR status 200",
            response,
            newAddApplication_data
          );
          if (
            response.data.message ===
            `VR_Application name '${newAddApplication_data.applicationName}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }

          dispatch(applicationVR_Reducer.addapplication_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          console.log("response add VR status not 200", response);
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        console.log("abc",err.response.data.message);
        if(err.response.data.message === "Missing mandatory input params"){
          dispatch(sidebarReducer.success(false));
          dispatch(sidebarReducer.failure(true));
          console.log("response add VR status error", err.response.data.message);
        }
        else{
          dispatch(sidebarReducer.success(false));
          dispatch(sidebarReducer.failure(true));
          console.log("response add VR status error", err);
          dispatch(sidebarReducer.stringUpdate("AppDown"));
          // dispatch(sidebarReducer.apiLoad(false));
        }
        
       
      });
  };
  const onDelete = async (applicationId) => {
    // dispatch(sidebarReducer.apiLoad(true));
    await axios
      .delete(`vr_applications/delete/${applicationId}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(applicationVR_Reducer.application_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListApplicationVR"));
          dispatch(applicationVR_Reducer.application_IsPane(false));
          dispatch(sidebarReducer.delete_success(true));

          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        dispatch(sidebarReducer.delete_success(false));
      });
  };

  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => {};
    // eslint-disable-next-line
  }, []);

  const handleReset = () => {
    // e.preventDefault();

    setAppFilter("");
    setAppselData("");
    setDummyAppfilter("");
    setDummyselData("");
    dispatch(applicationVR_Reducer.application_filter(true));
    responseData();
  };

  const handleReset1 = (e) => {
    setAppFilter("");
    setAppselData("");
  };
  // for filtering
  const handleSearch = async (e, TargetColomn, keyWord) => {
    e.preventDefault();
    // dispatch(sidebarReducer.apiLoad(true));

    if (TargetColomn === "te_appstatus") {
      if (keyWord === "active") {
        keyWord = "1";
      } else if (keyWord === "inactive") {
        keyWord = "0";
      }
    }
    await axios
      .get(
        `vr_applications/list?limit=${listLimit}&${TargetColomn}=${keyWord}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setListApp(response.data.data.rows);
          setAppCount(response.data.data.count);
          let pages =
            response.data.data.count === 0
              ? 1
              : Math.ceil(response.data.data.count / listLimit);
          setNoOfPages(pages);

          dispatch(applicationVR_Reducer.application_filter(false));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };
  return (
    <div>
      {View_Permission === 1 ? (
        <div className="Image container-fluid">
          {/** total content part in the layout */}
          <div className="row">
            <div className="col-12 p-0" style={{ minHeight: "90vh" }}>
              {/** ROW 1 for header */}
              <div className="row g-0 p-0 border">
                <div className="col">
                  <div
                    className="g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0">
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>VR Application</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row-reverse me-3">
                          <div className="p-2">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                color: "white",
                                minWidth: "160px",
                              }}
                              onClick={() => {
                                if (Add_Permission === 1) {
                                  dispatch(
                                    applicationVR_Reducer.add_VR_App(true)
                                  );
                                  dispatch(
                                    applicationVR_Reducer.addapplication_IsPane(
                                      true
                                    )
                                  );
                                  // dispatch(applicationReducer.application_filter(true));
                                  handleReset();
                                }
                              }}
                            >
                              <span
                                className="ToolTipB"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add
                                Application
                                <span
                                  className="ToolTipTextB"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "You can add the Application."
                                    : "You cannot add the Applicationr."}
                                </span>
                              </span>
                            </button>
                          </div>
                          <div className="dropdown p-2">
                            {application_filter ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "77px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  // handleSearch(
                                  //   e,
                                  //   AppselData,
                                  //   AppFilter.toLowerCase()
                                  // );
                                  // settableheight(true);
                                  dispatch(
                                    applicationVR_Reducer.application_filter(
                                      false
                                    )
                                  );
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "78px",
                                }}
                                onClick={() => {
                                  handleReset();
                                  // settableheight(false);
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/** ROW 2 for table */}
              <div className="row g-0 p-0 ">
                <div className="col">
                  <div>
                    {!application_IsPane && !addapplication_IsPane && (
                      <div className="accordion" id="accordionExample">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div
                            className="row accordion-body d-flex align-items-end p-2 "
                            style={{
                              backgroundColor: "#E3F7F9",
                              height: "90px",
                            }}
                          >
                            <div className="container">
                              <div className="row justify content start">
                                <div
                                  className="col-3"
                                  style={{
                                    // backgroundColor: "red",
                                    height: "80px",
                                    paddingTop: "20px",
                                    paddingLeft: "50px",
                                  }}
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        zIndex: "0",
                                      },
                                    }}
                                    value={AppFilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setAppFilter(val);
                                      setDummyAppfilter(val);
                                    }}
                                  />
                                </div>

                                <div
                                  className="col-3"
                                  style={{
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <FormControl sx={{ width: "90%" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={AppselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setAppselData(val);
                                        setDummyselData(val);
                                      }}
                                    >
                                      <MenuItem
                                        value="te_application_name"
                                        size="small"
                                      >
                                        Application Name
                                      </MenuItem>
                                      <MenuItem value="te_intended_device">
                                        Intended Device
                                      </MenuItem>
                                      <MenuItem value="te_appdescription">
                                        Application Description
                                      </MenuItem>
                                      <MenuItem value="te_appos">
                                        AppOS
                                      </MenuItem>
                                      <MenuItem value="te_appstatus">
                                        Status
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "blue",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white "
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                      // position: "relative",
                                      // top: "17px",
                                      // right: "-30px",
                                      // minWidth: "115px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(e, AppselData, AppFilter);
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      AppFilter.length > 0 &&
                                      AppselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "green",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                      setIsFilterIReset(true);
                                    }}
                                    disabled={
                                      AppFilter.length > 0 &&
                                      AppselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!apiLoad ? (
                      <div className="row AppCardMainp ps-3 pt-3">
                        {ListApp.length === 0 ? (
                          <h6
                            style={{ marginLeft: "500px", marginTop: "10px" }}
                          >
                            No Data Found
                          </h6>
                        ) : (
                          ListApp.map((item, index) => (
                            <div
                              className="card cardApp shadow col-md-6 col-sm-6 col-12 col-lg-4 col-xl-3 g-0"
                              key={index}
                              // onClick={() => {
                              //   editApp(item);
                              //   handleReset();
                              // }}
                              onClick={() => {
                                dispatch(
                                  applicationVR_Reducer.edit_VR_App(true)
                                );
                                onEdit(item);
                                handleReset();
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                flexWrap: "wrap",
                                maxWidth: "265px",
                                minWidth: "249px",
                              }}
                            >
                              <div className="d-flex flex-row">
                                <div
                                  className="img rounded-start"
                                  style={{
                                    backgroundColor: "var(--themes-color)",
                                  }}
                                >
                                  <div className="AppCardHead text-white">
                                    <span className="ToolTipA">
                                      <strong>
                                        {item.te_application_name}
                                      </strong>
                                      <span className="ToolTipTextA">
                                        Application Name
                                      </span>
                                    </span>
                                    <img
                                      style={{
                                        position: "absolute",
                                        top: "4px",
                                        height: "40px",
                                        width: "40px",
                                        left: "10px ",

                                        // borderRadius: "25px",
                                      }}
                                      src={
                                        item.te_appos === "ios"
                                          ? require("../../images/apple-logo-icon-14895.png")
                                          : item.te_appos === "windows"
                                          ? require("../../images/Windows_logo_-_2012.svg.png")
                                          : item.te_appos === "android"
                                          ? require("../../images/AndroidImg.png")
                                          : null
                                      }
                                      alt="C_LOGO"
                                    />
                                  </div>
                                </div>
                                <div className="data rounded">
                                  <div className="AppCardBody">
                                    <span className="ToolTipA">
                                      {item.te_appstatus === "1" && (
                                        <div
                                          className="rounded-circle text-center text-white"
                                          style={{
                                            position: "absolute",
                                            width: "20px",
                                            backgroundColor: "rgb(58,201,53)",
                                            top: "-15px",
                                            left: "-48px",
                                            height: "20px",
                                          }}
                                        ></div>
                                      )}
                                      {item.te_appstatus === "0" && (
                                        <div
                                          className="rounded-circle text-center text-white"
                                          style={{
                                            position: "absolute",
                                            width: "20px",
                                            backgroundColor: "rgb(201,53,53)",
                                            top: "-15px",
                                            left: "-48px",
                                            height: "20px",
                                          }}
                                        ></div>
                                      )}
                                      <span className="ToolTipTextA">
                                        {item.te_appstatus === "0"
                                          ? "Inactive"
                                          : "Active"}
                                      </span>
                                    </span>
                                    <ul className="p-0">
                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_buname}
                                          <span className="ToolTipTextA">
                                            Business Unit
                                          </span>
                                        </span>
                                      </li>
                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_divisionname}
                                          <span className="ToolTipTextA">
                                            Division
                                          </span>
                                        </span>
                                      </li>
                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_intended_device}
                                          <span className="ToolTipTextA">
                                            Intended Device
                                          </span>
                                        </span>
                                      </li>

                                      <li className="applicationli">
                                        <span className="ToolTipA">
                                          {item.te_appdescription}
                                          <span className="ToolTipTextA">
                                            App Description
                                          </span>
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "80vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div className="spinnerApi"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* pagination footer */}
            <div className="container">
              <div className="row main-footer">
                <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                  Total Records: {AppCount}
                </div>
                <div className="col-4 mt-2">
                  <div className="d-flex justify-content-center ">
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          leftEndArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== 1 && leftArrow();
                        }}
                      ></i>
                    </div>
                    <div
                      className={
                        noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                      }
                      style={
                        index1_pagenation === pageSelected ? onPage : notOnPage
                      }
                      onClick={() => {
                        pagenationAPi(index1_pagenation, AppselData, AppFilter);
                      }}
                    >
                      {index1_pagenation}
                    </div>
                    {noOfPages > 1 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index2_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index2_pagenation,
                            AppselData,
                            AppFilter
                          );
                        }}
                      >
                        {index2_pagenation}
                      </div>
                    )}
                    {noOfPages > 2 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index3_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index3_pagenation,
                            AppselData,
                            AppFilter
                          );
                        }}
                      >
                        {index3_pagenation}
                      </div>
                    )}
                    {noOfPages > 3 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index4_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index4_pagenation,
                            AppselData,
                            AppFilter
                          );
                        }}
                      >
                        {index4_pagenation}
                      </div>
                    )}
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== noOfPages && rightArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          rightEndArrow();
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="col-3 mt-2 ">
                  <div className="d-flex justify-content-end me-3">
                    <span>
                      <strong>Page {pageSelected} </strong> of{" "}
                      <strong>{noOfPages}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Editing application sliding pane VR */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="70%"
            hideHeader
            isOpen={application_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              onCancel();
            }}
          >
            <div>
              <div
                className="d-flex border align-items-center"
                style={{ backgroundColor: "#f2f3f5" }}
              >
                <div
                  className="p-2 border-end"
                  onClick={() => {
                    // editReset();
                    dispatch(applicationVR_Reducer.application_edit(false));
                    dispatch(applicationVR_Reducer.bu_edit(false));
                    dispatch(sidebarReducer.stringUpdate("ListApplicationVR"));
                    dispatch(applicationVR_Reducer.application_IsPane(false));
                  }}
                >
                  <div className="ms-1 me-1">
                    <i className="bi bi-arrow-right"></i>
                  </div>
                </div>
                <div className="me-auto mt-1 ms-2">
                  <h5>
                    <strong>{application_name}</strong>
                  </h5>
                </div>
                <div className="mode p-2">
                  <div className="d-flex justify-content-center">
                    <i>
                      <strong style={{ color: "blue" }}>
                        {application_edit ? "Edit Mode" : "View Mode"}
                      </strong>
                    </i>
                  </div>
                </div>
                <div className="border-start ">
                  <button
                    className="button editApp"
                    // data-bs-toggle="modal"
                    data-bs-target="#DeleteUser"
                    // data-backdrop="false"
                    style={{
                      zIndex: "1100",
                      border: "none",
                      height: "45px",
                      minWidth: "85px",
                    }}
                    onClick={() => {
                      Delete_Permission === 1 && setPopUp(true);
                    }}
                  >
                    <span
                      className="ToolTipBDelete"
                      style={
                        {
                          // backgroundColor:
                          //   "var(--themes-color)"
                        }
                      }
                    >
                      <i className="bi bi-trash-fill"></i>&nbsp; Delete record
                      <span
                        className="ToolTipTextBDelete"
                        style={{
                          backgroundColor:
                            Delete_Permission === 1
                              ? "var(--themes-color)"
                              : "red",
                        }}
                      >
                        {Delete_Permission === 1
                          ? "You can delete the Application."
                          : "You cannot delete the Application."}
                      </span>
                    </span>
                  </button>
                </div>
                {application_edit && (
                  <div
                    className="border-start"
                    style={{ height: "45px" }}
                    onClick={onCancel}
                  >
                    <button
                      className="button editApp"
                      style={{
                        // paddingTop: "3px",
                        border: "none",
                        height: "45px",
                        minWidth: "85px",
                      }}
                      // onClick={() => {
                      //   dispatch(applicationVR_Reducer.edit_Mode(false));
                      //   dispatch(applicationVR_Reducer.application_edit(false));
                      // }}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                      &nbsp;Cancel Changes
                    </button>
                  </div>
                )}
                <div className="border-start">
                  {application_edit ? (
                    <button
                      className="button editApp"
                      style={{
                        border: "none",
                        height: "45px",
                      }}
                      onClick={() => {
                        onUpdate(applicationId);
                        console.log("editing the values", applicationId);
                      }}
                    >
                      <i className="bi bi-file-earmark-diff-fill"></i>
                      &nbsp;Save Changes
                    </button>
                  ) : (
                    <button
                      className="button editApp"
                      style={{
                        zIndex: "1100",
                        // paddingTop: "3px",
                        border: "none",
                        height: "45px",
                      }}
                      onClick={() => {
                        // dispatch(applicationVR_Reducer.edit_Mode(true));
                        // dispatch(applicationVR_Reducer.application_edit(true));
                        Edit_Permission === 1 &&
                          dispatch(
                            applicationVR_Reducer.application_edit(
                              !application_edit
                            )
                          );
                      }}
                    >
                      <span
                        className="ToolTipBEdit"
                        // style={{
                        //   backgroundColor: "var(--themes-color)",
                        // }}
                      >
                        <i className="bi bi-pencil-fill"></i>&nbsp; Edit Record
                        <span
                          className="ToolTipTextBEdit"
                          style={{
                            backgroundColor:
                              Edit_Permission === 1
                                ? "var(--themes-color)"
                                : "red",
                          }}
                        >
                          {Edit_Permission === 1
                            ? "You can edit the Application."
                            : "You cannot edit the Application."}
                        </span>
                      </span>
                    </button>
                  )}
                </div>
              </div>
              <div
                className="ps-3 py-3 pe-3"
                style={{ overflowY: "auto", height: "80vh" }}
              >
                <div className="mb-3">
                  <TextField
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="Application Name"
                    size="small"
                    value={applicationName}
                    variant="outlined"
                    onChange={(e) => {
                      setApplicationName(e.target.value);
                    }}
                    disabled={application_edit ? false : true}
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="Description"
                    size="small"
                    variant="outlined"
                    value={appDescription}
                    onChange={(e) => {
                      setApplicationDescription(e.target.value);
                    }}
                    disabled={application_edit ? false : true}
                  />
                </div>
                <div
                  className="mb-3"
                  onMouseDown={() => {
                    if (application_edit)
                      setIntendedDeviceName("Intended Device");
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" size="small">
                      {intendedDevice}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      label="Intended Device"
                      variant="outlined"
                      // value={intendedDevice}
                      onChange={(e) => {
                        let val = e.target.value;
                        setIntendedDevice(val);
                      }}
                      disabled={application_edit ? false : true}
                    >
                      <MenuItem
                        value="oculus quest"
                        onClick={() => {
                          setIntendedDeviceName("Intended Device");
                        }}
                      >
                        oculus quest
                      </MenuItem>
                      <MenuItem
                        value="Htc vive"
                        onClick={() => {
                          setIntendedDeviceName("Intended Device");
                        }}
                      >
                        Htc vive
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div
                  className="mb-3"
                  onMouseDown={() => {
                    if (application_edit) setApplicationOSheading("OS");
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" size="small">
                      {appOSheading}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      disabled={application_edit ? false : true}
                      label="OS"
                      variant="outlined"
                      // value={appOS}
                      size="small"
                      onChange={(e) => {
                        let val = e.target.value;
                        setApplicationOS(val);
                      }}
                    >
                      <MenuItem
                        value="android"
                        onClick={() => {
                          setApplicationOSheading("OS");
                        }}
                      >
                        Android
                      </MenuItem>
                      <MenuItem
                        value="ios"
                        onClick={() => {
                          setApplicationOSheading("OS");
                        }}
                      >
                        iOS
                      </MenuItem>
                      <MenuItem
                        value="windows"
                        onClick={() => {
                          setApplicationOSheading("OS");
                        }}
                      >
                        Windows
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div
                  className="mb-3"
                  onMouseDown={() => {
                    if (application_edit) setBusinessunitName("Business Unit");
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" size="small">
                      {businessunitName}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      // value={age}
                      disabled={application_edit ? false : true}
                      label="Business Unit"
                      variant="outlined"
                      onChange={(e) => {
                        dispatch(applicationVR_Reducer.bu_edit(true));
                        let val = e.target.value;
                        setBusinessunitData(e.target.value);
                        // console.log(val, "val bu");
                        DivisionResponse(val);
                      }}
                    >
                      {buData.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.te_buid}
                          onClick={() => {
                            setBusinessunitName("Business Unit");
                          }}
                        >
                          {item.te_buname}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div
                  className="mb-3"
                  onMouseDown={() => {
                    if (application_edit && bu_edit)
                      setDivisionName("Division");
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" size="small">
                      {divisionName}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      disabled={bu_edit ? false : true}
                      size="small"
                      label="Division"
                      variant="outlined"
                      onChange={(e) => {
                        // setEditDisionData(e.target.value);
                        setEditDivisionId(e.target.value);
                        // setEditDisionData(e.target.value);
                        // console.log(e.target.value, "val div");
                      }}
                    >
                      {divisionData.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.te_divisionid}
                          onClick={() => {
                            setDivisionName("Division");
                          }}
                        >
                          {item.te_divisionname}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" size="small">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      label="Status"
                      variant="outlined"
                      value={appStatus}
                      onChange={(e) => {
                        let val = e.target.value;
                        setAppStatus(val);
                      }}
                      disabled={application_edit ? false : true}
                    >
                      <MenuItem value="1">Active</MenuItem>
                      <MenuItem value="0">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
          </SlidingPane>

          {/* Adding application sliding pane VR */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="71%"
            hideHeader
            isOpen={addapplication_IsPane}
            onRequestClose={() => {
              // addReset();
            }}
          >
            <div>
              <div
                className="d-flex align-items-center border"
                style={{ backgroundColor: "#f2f3f5", height: "45px" }}
              >
                <div
                  className="px-2 my-1"
                  onClick={() => {
                    dispatch(sidebarReducer.stringUpdate("ListApplicationVR"));
                    dispatch(
                      applicationVR_Reducer.addapplication_IsPane(false)
                    );
                    dispatch(applicationVR_Reducer.bu_edit(false));
                  }}
                >
                  <i className="bi bi-arrow-right"></i>
                </div>
                <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                  <h5 style={{ whiteSpace: "nowrap" }}>
                    <strong>Add Application</strong>
                  </h5>
                </div>
              </div>
              <form
                className="ps-3 py-3 pe-3"
                style={{ overflowY: "auto", height: "80vh" }}
                onSubmit={onAddapplication}
              >
                <div className="mb-3">
                  <TextField
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="Application Name"
                    size="small"
                    variant="outlined"
                    required
                    onChange={(e) => {
                      setNewApplication(e.target.value);
                    }}
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    label="Description"
                    size="small"
                    variant="outlined"
                    required
                    onChange={(e) => {
                      setNewDescription(e.target.value);
                    }}
                  />
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      // required
                    >
                      Intended Device
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      label="Intended Device"
                      variant="outlined"
                      onChange={(e) => {
                        let val = e.target.value;
                        setNewIntendedDevice(val);
                      }}
                    >
                      <MenuItem value="oculus quest">oculus quest</MenuItem>
                      <MenuItem value="Htc vive">Htc vive</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      // required
                    >
                      OS
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      label="OS"
                      variant="outlined"
                      onChange={(e) => {
                        let val = e.target.value;
                        setAppOS(val);
                      }}
                    >
                      <MenuItem value={"android"}>Android</MenuItem>
                      <MenuItem value={"ios"}>iOS</MenuItem>
                      <MenuItem value={"windows"}>Windows</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      // required
                    >
                      Business Unit
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Business Unit"
                      variant="outlined"
                      size="small"
                      // required
                      onChange={(e) => {
                        let val = e.target.value;
                        DivisionResponse(val);

                        dispatch(applicationVR_Reducer.bu_edit(true));
                      }}
                    >
                      {buData.map((item, index) => (
                        <MenuItem key={index} value={item.te_buid}>
                          {item.te_buname}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      required
                    >
                      Division
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Division"
                      size="small"
                      variant="outlined"
                      required
                      onChange={(e) => {
                        setNewDivisionId(e.target.value);
                        console.log("newDivisionID", newDivisionId);
                      }}
                      disabled={bu_edit ? false : true}
                      // disabled={bu_edit ? false : true}
                    >
                      {divisionData.map((item, index) => (
                        <MenuItem key={index} value={item.te_divisionid}>
                          {item.te_divisionname}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      size="small"
                      required
                    >
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      label="Status"
                      variant="outlined"
                      onChange={(e) => {
                        let val = e.target.value;
                        setNewStatus(val);
                      }}
                    >
                      <MenuItem value="1">Active</MenuItem>
                      <MenuItem value="0">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-3">
                  <button
                    className="btn"
                    type="submit"
                    style={{
                      backgroundColor: "var(--themes-color)",
                      color: "white",
                    }}
                  >
                    &nbsp;Submit
                  </button>
                </div>
              </form>
            </div>
          </SlidingPane>
          <Modal
            open={popUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <center>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6>
                    {IsDependent
                      ? " This Application has dependency, Cannot delete this Appliaction"
                      : "Are you sure you want to delete this Application?"}
                  </h6>
                </div>

                <div className="pt-4">
                  {!IsDependent && (
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        width: "100px",
                      }}
                      onClick={() => {
                        setPopUp(false);
                        onDelete(applicationId);
                        console.log("Deleted division id", applicationId);
                      }}
                    >
                      Delete
                    </button>
                  )}
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      // backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </center>
            </Box>
          </Modal>
          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          {/* This div comes when the user do not have permission to view this page. */}
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListApplicationVR;
